"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = exports.Group = exports.Form = exports.FormContext = exports.isHTMLField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var kea_1 = require("kea");
var utils_1 = require("./utils");
var react_1 = require("react");
var isHTMLField = function (type) { return ['input', 'select', 'textarea'].includes(type); };
exports.isHTMLField = isHTMLField;
exports.FormContext = React.createContext({});
function Form(_a) {
    var logic = _a.logic, props = _a.props, formKey = _a.formKey, children = _a.children, enableFormOnSubmit = _a.enableFormOnSubmit, otherProps = __rest(_a, ["logic", "props", "formKey", "children", "enableFormOnSubmit"]);
    var builtLogic = (0, kea_1.useMountedLogic)(props ? logic(props) : logic);
    var newFormContext = (0, react_1.useMemo)(function () { return ({ logic: builtLogic, formKey: formKey }); }, [builtLogic, formKey]);
    return ((0, jsx_runtime_1.jsx)(exports.FormContext.Provider, { value: newFormContext, children: (0, jsx_runtime_1.jsx)("form", __assign({ onSubmit: function (e) {
                var _a, _b;
                e.preventDefault();
                if (enableFormOnSubmit) {
                    (_b = (_a = builtLogic.actions)["submit".concat((0, utils_1.capitalizeFirstLetter)(formKey))]) === null || _b === void 0 ? void 0 : _b.call(_a);
                }
            } }, otherProps, { children: children })) }));
}
exports.Form = Form;
function Group(_a) {
    var name = _a.name, children = _a.children;
    var formContext = (0, react_1.useContext)(exports.FormContext);
    var namePath = __spreadArray(__spreadArray([], (formContext.namePrefix || []), true), (Array.isArray(name) ? name : (0, utils_1.splitPathKey)(name)), true);
    var newFormContext = (0, react_1.useMemo)(function () { return (__assign(__assign({}, formContext), { namePrefix: namePath })); }, [formContext, namePath.join('.')]);
    return (0, jsx_runtime_1.jsx)(exports.FormContext.Provider, { value: newFormContext, children: children });
}
exports.Group = Group;
function Field(_a) {
    var name = _a.name, label = _a.label, hint = _a.hint, noStyle = _a.noStyle, children = _a.children, template = _a.template;
    var _b = (0, react_1.useContext)(exports.FormContext), logic = _b.logic, formKey = _b.formKey, namePrefix = _b.namePrefix;
    if (!logic) {
        throw new Error('Please pass a "logic" to the <Form /> tag.');
    }
    if (!formKey) {
        throw new Error('Please pass a "formKey" to the <Form /> tag.');
    }
    var capitalizedFormKey = (0, utils_1.capitalizeFirstLetter)(formKey);
    var _c = (0, kea_1.useActions)(logic), _d = "set".concat(capitalizedFormKey, "Value"), setValue = _c[_d], _e = "touch".concat(capitalizedFormKey, "Field"), touchField = _c[_e];
    var namePath = __spreadArray(__spreadArray([], (namePrefix || []), true), (Array.isArray(name) ? name : (0, utils_1.splitPathKey)(name)), true);
    var nameString = namePath.join('.');
    var value = (0, kea_1.useSelector)(function (state) { var _a, _b; return (0, utils_1.pathSelector)(namePath, (_b = logic === null || logic === void 0 ? void 0 : (_a = logic.selectors)[formKey]) === null || _b === void 0 ? void 0 : _b.call(_a, state)); });
    var error = (0, kea_1.useSelector)(function (state) { var _a, _b; return (0, utils_1.pathSelector)(namePath, (_b = logic === null || logic === void 0 ? void 0 : (_a = logic.selectors)["".concat(formKey, "Errors")]) === null || _b === void 0 ? void 0 : _b.call(_a, state)); });
    var id = "".concat(logic === null || logic === void 0 ? void 0 : logic.pathString, ".").concat(formKey, ".").concat(nameString);
    var newProps = {
        id: id,
        name: name,
        value: value,
        error: error,
        onBlur: function () {
            touchField(nameString);
        },
        onChange: function (c) {
            setValue(namePath, c);
        },
    };
    var kids;
    if (typeof children === 'function') {
        kids = children(__assign(__assign({}, newProps), { onChangeEvent: function (e) {
                var _a;
                setValue(namePath, (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
            } }));
    }
    else if (children) {
        var isHTMLElement = typeof children.type === 'string' && (0, exports.isHTMLField)(children.type);
        if (isHTMLElement) {
            kids = React.cloneElement(children, __assign(__assign(__assign({}, newProps), { value: isHTMLElement ? value || '' : value, onChange: function (e) {
                    var _a;
                    setValue(namePath, (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
                } }), children.props));
        }
        else {
            kids = React.cloneElement(children, __assign(__assign({}, newProps), children.props));
        }
    }
    else {
        kids = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    if (template) {
        return template({ label: label, kids: kids, error: error, hint: hint });
    }
    if (noStyle) {
        return kids;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "form-input-container", children: [label ? (0, jsx_runtime_1.jsx)("label", { htmlFor: id, children: label }) : null, kids, error ? (0, jsx_runtime_1.jsx)("div", { className: "form-error", children: error }) : null, hint ? (0, jsx_runtime_1.jsx)("div", { className: "form-hint", children: hint }) : null] }));
}
exports.Field = Field;
//# sourceMappingURL=components.js.map